import BaseFormation from "./BaseFormation";
import TreasureFormation from "./TreasureFormation";
import { FormationConfig } from "./BaseFormation";

export default class FormationManager {
  private scene: Phaser.Scene;
  formations: BaseFormation[] = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  createTreasureFormation(x: number, y: number, config: FormationConfig) {
    const formation = new TreasureFormation(this.scene, x, y, config);
    this.formations.push(formation);
    return formation;
  }

  update() {
    this.formations = this.formations.filter((formation) => {
      if (formation.isActive()) {
        formation.update();
        return true;
      }
      formation.destroy();
      return false;
    });
  }

  clear() {
    this.formations.forEach((formation) => formation.destroy());
    this.formations = [];
  }
}
